export default __webpack_public_path__ + "static/media/ic_arrow_right.641b05c7.svg";